import { render } from "./CluesModal.vue?vue&type=template&id=61bade56&scoped=true"
import script from "./CluesModal.vue?vue&type=script&lang=js"
export * from "./CluesModal.vue?vue&type=script&lang=js"

import "./CluesModal.vue?vue&type=style&index=0&id=61bade56&scoped=true&lang=sass"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@5.107.2_cssnano@5.1.15_postcss@8.5.15__postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bade56"]])

export default __exports__